import { Directive, inject } from '@angular/core';
import { IModelDataV3WithUrl, Model } from '@df/catalog/model';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { Meta } from '@df/core/meta/meta';
import { GiftcardsProductComponentDef } from '@df/module-giftcards/giftcards-product.component.def';


/**
 * @deprecated Please don't use it
 */
@Directive()
export abstract class GiftcardsProductViewComponentDef<
    T extends Product<IProductDataV3> = Product<IProductDataV3>
> extends GiftcardsProductComponentDef<T> {
    override verbosity = 3;

    private meta = inject(Meta);

    /**
     * Update meta on model change
     */
    protected override onModelChange(): void {
        this.meta.model = <Model<IModelDataV3WithUrl>>this.model;
        super.onModelChange();
    }
}
